<template>
  <div class="container">
    <div class="cart_pro_list">
      <div class="list">
        <pro-item v-for="(item, index) of list" :key="index" :productItem="item"></pro-item>
      </div>
      <div class="numtotal">
        <van-cell title="海外商品" label="订单中国包含海外商品，需要填写身份证号信息" class="overseas_desc" title-class="overseas_desc_tit"
                  label-class="overseas_desc_label"/>
      </div>
    </div>
    <div class="cart_overseas">
      <div class="tit">
        收件人信息
      </div>
      <van-cell-group>
        <van-field label-width="20%">
          <template slot="label">
            <div class="real_label">
              <span>姓名</span>
            </div>
          </template>
          <template slot="input">
            <input placeholder="请输入真实姓名" class="inp" v-model="name"/>
          </template>
        </van-field>
        <van-field label-width="20%">
          <template slot="label">
            <div class="real_label">
              <span>身份证号</span>
            </div>
          </template>
          <template slot="input">
            <input placeholder="请输入身份证号" minlength="16" class="inp" v-model="card"/>
          </template>
        </van-field>
      </van-cell-group>
    </div>

    <div class="btn" @click="goOrder">提交</div>
  </div>
</template>

<script>
import proItem from '../common/cart_pro_item'
import { isWeixin, fenxiang } from '../../assets/common/js/config'

export default {
  name: 'identity',
  data () {
    return {
      name: '',
      card: '',
      list: []
    }
  },
  components: {
    proItem
  },
  mounted () {
    if (isWeixin()) {
      fenxiang({path: 'identity'})
    }
    if (sessionStorage.getItem('oversea_List')) {
      this.list = JSON.parse(sessionStorage.getItem('oversea_List'))
    }
  },
  methods: {
    goOrder () {
      if (this.name.trim() == '') {
        this.$toast('姓名不能为空')
        return
      } else if (this.card.trim() == '') {
        this.$toast('身份证号不能为空')
        return
      } else if (this.card.trim().length < 16) {
        this.$toast('身份证号输入有误')
        return
      }
      var url = this.$ajax.addRealname_URL
      var data = {
        realname: this.name,
        idcardno: this.card,
        addressid: this.$route.query.addressid
      }
      this.$customRequestAjax.post(url, data).then(res => {
        if (res.data.code === 200) {
          var query = this.$route.query
          this.$router.replace({path: '/order',
            query: query
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
  .container {
    .cart_pro_list {
      border-radius: .04rem;
      background: #fff;
      margin: .1rem .11rem;
      padding: .1rem .15rem;
      .list {
        padding-bottom: .2rem;
        font-size: .14rem;
        position: relative;
      }
      .list:after {
        position: absolute;
        box-sizing: border-box;
        content: ' ';
        pointer-events: none;
        right: 0;
        bottom: 0;
        left: 0;
        border-bottom: 1px solid #D8D8D8;
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
      }
      .numtotal {
        font-size: .12rem;
        line-height: .45rem;
        color: #3D3D3D;
        .overseas_desc {
          padding: .1rem 0;
          .overseas_desc_tit {
            font-size: .15rem;
            line-height: .21rem;
            color: #222222;
          }
          .overseas_desc_label {
            color: #6C6C6C;
          }
        }
      }
    }
    .cart_overseas {
      border-radius: .04rem;
      background: #fff;
      margin: .1rem .11rem;
      .tit {
        font-size: .13rem;
        color: #000;
        padding: .15rem;
        line-height: .18rem;
        padding-bottom: .1rem;
        position: relative;
      }
      .tit:after {
        position: absolute;
        box-sizing: border-box;
        content: ' ';
        pointer-events: none;
        right: .15rem;
        bottom: 0;
        left: .15rem;
        border-bottom: 1px solid #D8D8D8;
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
      }
      .real_label {
        font-size: .12rem;
        color: #1D1E1E;
        padding: .07rem 0;
      }
      .inp {
        background: #F6F7FA;
        border-radius: .02rem;
        border: 0;
        width: 100%;
        padding: .07rem .1rem;
        color:#444444;
      }
      .van-cell-group {
        padding: .1rem 0;
      }
      .van-cell:not(:last-child)::after, .van-hairline--top-bottom::after {
        border: 0;
      }
      .van-cell {
        padding-top: .05rem;
        padding-bottom: .05rem;
      }
    }
    .btn{
      position: fixed;
      bottom: .1rem;
      left:.11rem;
      right:.11rem;
      height:.43rem;
      line-height: .43rem;
      background:linear-gradient(90deg,rgba(252,3,36,1) 0%,rgba(246,58,102,1) 100%);
      border-radius:.25rem;
      font-size: .17rem;
      color:#fff;
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/shopcart/identity.vue